export default __webpack_public_path__ + "static/media/q_wdt_c_5.c1969e33.mp3";